<div class="rb-page">
  <header class="rb-head">
    <div class="rb-head-text">
      <h1 class="rb-title">{{ "profile.team_title" | translate }}</h1>
      <p class="rb-desc">{{ "profile.rubrica.desc_short" | translate }}</p>
      <a class="rb-link" routerLink="/profilo" [queryParams]="{ tab: 'team' }">
        {{ "profile.tabs.team" | translate }} →
      </a>
    </div>
    <button type="button" class="btn-gold rb-add" *ngIf="canPro && team.length > 0 && editingTeamIndex < 0" (click)="addTeamMember()">
      <app-icon name="plus" [size]="16"></app-icon>
      {{ "profile.rubrica.add" | translate }}
    </button>
  </header>

  <!-- Piano non Pro: un solo avviso, nessun pulsante bloccato -->
  <div *ngIf="!canPro" class="rb-pro">
    <app-icon name="lock" [size]="16"></app-icon>
    <span class="rb-pro-text">{{ "profile.rubrica.pro_lock" | translate }}</span>
    <button type="button" class="rb-pro-btn" (click)="goToPlans()">{{ "riepilogo.team_pro_cta" | translate }}</button>
  </div>

  <!-- Lista vuota -->
  <app-load-error *ngIf="loadError" (retry)="load()"></app-load-error>

  <div class="rb-empty" *ngIf="team.length === 0 && teamLoaded">
    <app-icon name="users" [size]="28"></app-icon>
    <p class="rb-empty-title">{{ "profile.team_empty" | translate }}</p>
    <p class="rb-empty-desc">{{ "profile.team_empty_desc" | translate }}</p>
    <button type="button" class="btn-gold rb-empty-btn" *ngIf="canPro" (click)="addTeamMember()">
      <app-icon name="plus" [size]="16"></app-icon>
      {{ "profile.rubrica.add" | translate }}
    </button>
  </div>

  <!-- Elenco a righe -->
  <div class="rb-list" *ngIf="team.length > 0">
    <ng-container *ngFor="let member of team; let i = index">
      <!-- RIGA -->
      <button
        type="button"
        class="rb-row"
        *ngIf="editingTeamIndex !== i"
        [class.unavailable]="member.available === false"
        (click)="startEdit(i)"
      >
        <span class="rb-avatar">{{ initials(member) }}</span>
        <span class="rb-main">
          <span class="rb-name">{{ member.name }} {{ member.lastname }}</span>
          <span class="rb-meta">
            <span class="rb-chip" *ngFor="let r of roleKeys(member.service)">{{ r | translate }}</span>
            <span class="rb-chip muted" *ngIf="member.available === false">{{ "profile.not_available" | translate }}</span>
            <span class="rb-chip app" *ngIf="nyzedUserCheck[i]">{{ "profile.rubrica.on_app" | translate }}</span>
          </span>
        </span>
        <span class="rb-chevron">›</span>
      </button>

      <!-- MODIFICA -->
      <div class="rb-edit" *ngIf="editingTeamIndex === i">
        <div class="rb-field-row">
          <label class="rb-field">
            <span>{{ "profile.rubrica.name" | translate }}</span>
            <input type="text" [(ngModel)]="member.name" autocomplete="given-name" />
          </label>
          <label class="rb-field">
            <span>{{ "profile.rubrica.lastname" | translate }}</span>
            <input type="text" [(ngModel)]="member.lastname" autocomplete="family-name" />
          </label>
        </div>

        <label class="rb-field">
          <span>
            {{ "profile.fields.email" | translate }}
            <em class="rb-app-tag" *ngIf="nyzedUserCheck[i]">{{ "profile.rubrica.app_user" | translate }}</em>
          </span>
          <input
            type="email"
            [(ngModel)]="member.email"
            [placeholder]="'profile.team_email_placeholder' | translate"
            autocapitalize="off"
            inputmode="email"
            (blur)="checkNyzedUser(member.email, i)"
          />
        </label>

        <div class="rb-field">
          <span>{{ "profile.team_role_label" | translate }}</span>
          <div class="rb-roles">
            <label class="rb-role" [class.active]="member.service?.makeup">
              <input type="checkbox" [(ngModel)]="member.service.makeup" />
              {{ "profile.trucco" | translate }}
            </label>
            <label class="rb-role" [class.active]="member.service?.hair">
              <input type="checkbox" [(ngModel)]="member.service.hair" />
              {{ "profile.capelli" | translate }}
            </label>
            <label class="rb-role" [class.active]="member.service?.photo">
              <input type="checkbox" [(ngModel)]="member.service.photo" />
              {{ "profile.foto" | translate }}
            </label>
          </div>
        </div>

        <label class="rb-field">
          <span>{{ "profile.team_notes_label" | translate }}</span>
          <textarea
            [(ngModel)]="member.notes"
            [placeholder]="'profile.team_notes_placeholder' | translate"
            rows="2"
          ></textarea>
        </label>

        <label class="rb-toggle">
          <span>{{ "profile.rubrica.available_label" | translate }}</span>
          <span class="toggle-switch">
            <input type="checkbox" [(ngModel)]="member.available" />
            <span class="toggle-slider"></span>
          </span>
        </label>

        <div class="rb-actions">
          <button type="button" class="btn-outline rb-cancel" (click)="cancelEdit(i)">
            {{ "common.cancel" | translate }}
          </button>
          <button type="button" class="btn-gold rb-save" (click)="saveTeamMember(i)">
            {{ "common.save" | translate }}
          </button>
        </div>

        <div class="rb-secondary">
          <button
            type="button"
            class="rb-text-btn"
            *ngIf="member.email && !nyzedUserCheck[i]"
            (click)="inviteToNyzed(member.email, member.name)"
          >
            <app-icon name="send" [size]="15"></app-icon>
            {{ "profile.rubrica.invite_app" | translate }}
          </button>
          <button type="button" class="rb-text-btn danger" (click)="removeTeamMember(i)">
            <app-icon name="trash" [size]="15"></app-icon>
            {{ "common.delete" | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
